import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { IPriceFiltering, IPriceFilteringData } from './priceFiltering.interface';

export namespace PriceFilteringAction {
  const actionCreator = actionCreatorFactory('PriceFiltering');

  export const loadList = actionCreator.async<void, IPriceFilteringData, IApiErrorParams>('LOAD_LIST');

  interface IPriceFilteringCreateParams extends IPriceFiltering, Pick<IResolverMeta, 'reject'> {}

  interface IPriceFilteringUpdateParams extends IPriceFiltering, Pick<IResolverMeta, 'reject'> {}

  export const create = actionCreator.async<
    IPriceFilteringCreateParams,
    {
      priceFilteringId: IPriceFiltering['priceFilteringId'];
    },
    IApiErrorParams
  >('CREATE');
  export const update = actionCreator.async<IPriceFilteringUpdateParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ priceFilteringId: IPriceFiltering['priceFilteringId'] }, void, IApiErrorParams>('REMOVE');

  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
